// extracted by mini-css-extract-plugin
export default {"wrapper":"Products_wrapper__aniuN"};